
import Vue from "vue";
import AppExtraFieldsEdit from "@/components/ExtraFieldsEdit.vue";
import { ExtraFieldNamesConfig } from "@/models/dossier-configs/extra-field-names-config";
import { DossierConfigService } from "@/services";
import { Bank } from "@/models/base";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => Bank,
			required: true
		},
	},
	computed: {
		extraFieldsNameSettings():ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().BankNames;
		}
	},
	components: {
		AppExtraFieldsEdit
	},
	i18nEx: {
		componentPrefix: "components.bank"
	}
});

